'use strict';

var _require = require('./messages'),
    NO_WINDOW_WARNING = _require.NO_WINDOW_WARNING;

function getDataLayer(window, customDataLayer) {
  if (customDataLayer !== undefined && typeof customDataLayer.push === 'function') {
    return customDataLayer;
  }
  if (window !== undefined) {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }
  console.warn(NO_WINDOW_WARNING);
  return undefined;
}

module.exports = getDataLayer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/get-data-layer.js
// module id = 174
// module chunks = 0